module.exports = __webpack_public_path__ + "static/img/banner_3.3c384e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thirdAnniversary/3/banner_3.png
// module id = 1NXe
// module chunks = 2